import * as React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import getColumnName from "./helpers/getColumnName";
import { _fileCell, actionCell, customCell, emptyCell, fileCell } from "./helpers/cells";
import { TableColum } from "../interfaces";

interface CellProps {
	idx: number;
	column: TableColum;
	titleRow: string;
	last?: boolean;
	optionsFromUrl?: Array<{ id: string, name: string }>;
}

const width = { width: "55px" };
const whiteSpace = { whiteSpace: "normal" };

const thStyleLast = { border: "unset", height: "0px", padding: "0px" };

const Cell = (props: CellProps) => {
	const { column, idx, titleRow, last, optionsFromUrl } = props;
	const type = typeof column.type === "string" ? column.type.toUpperCase() : column.type;
	let dropboxColumn;

	if (type === "DROPBOX") {
		dropboxColumn = {
			...column,
			urlOptions: optionsFromUrl
		}
	}

	const basicProps = {
		key: idx,
		isKey: column.isKey,
		hidden: column.isKey,
		dataField: column.field,
	};

	switch (type) {
		case null:
			return <TableHeaderColumn {...basicProps} />;
		case "_FILE": {
			return (
				<TableHeaderColumn {...basicProps} thStyle={whiteSpace} tdStyle={whiteSpace} dataFormat={_fileCell}>
					{getColumnName(column, titleRow)}
				</TableHeaderColumn>
			)
		}
		case "FILE":
			return (
				<TableHeaderColumn {...basicProps} thStyle={whiteSpace} tdStyle={whiteSpace} dataFormat={fileCell}>
					{getColumnName(column, titleRow)}
				</TableHeaderColumn>
			);
		case "ACTION": {
			if (last) {
				return (
					<TableHeaderColumn
						{...basicProps}
						thStyle={thStyleLast}
						tdStyle={{ ...whiteSpace, ...width }}
						dataFormat={emptyCell}
					/>
				);
			}
			return (
				<TableHeaderColumn
					{...basicProps}
					thStyle={{ ...whiteSpace, ...width }}
					tdStyle={{ ...whiteSpace, ...width }}
					dataFormat={actionCell}
				/>
			);
		}
		case 'DROPBOX': {
			return (
				<TableHeaderColumn {...basicProps} thStyle={whiteSpace} tdStyle={whiteSpace} dataFormat={customCell.bind(dropboxColumn)}>
					{getColumnName(column, titleRow)}
				</TableHeaderColumn>
			);
		}
		default: {
			if (last) {
				return <TableHeaderColumn {...basicProps} thStyle={thStyleLast} tdStyle={whiteSpace} dataFormat={customCell.bind(column)} />;
			}
			return (
				<TableHeaderColumn {...basicProps} thStyle={whiteSpace} tdStyle={whiteSpace} dataFormat={customCell.bind(column)}>
					{getColumnName(column, titleRow)}
				</TableHeaderColumn>
			);
		}
	}
};

export default Cell;
